import { Box } from '@primer/react';
import { Contributors } from '@primer/gatsby-theme-doctocat';
import * as React from 'react';
export default {
  Box,
  Contributors,
  React
};